import { render, staticRenderFns } from "./app-info-query.vue?vue&type=template&id=4431be9f"
import script from "./app-info-query.vue?vue&type=script&lang=ts"
export * from "./app-info-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports